// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> confluence-at-harvest-hills
// Generated: 2026-11-02T18:10:24.869Z
// Counts: 0 design, 39 content, 20 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Flexible Living - One, Two, and Three Bedrooms</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Living in Vibrant Harvest Hills</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Life Near the Heart of Williston</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Confluence at Harvest Hills, you'll find everyday comfort with in-home perks and inviting shared spaces. Each apartment home offers large closets, energy-efficient appliances, a washer and dryer, roomy cabinets, deep double sinks, large windows, a breakfast bar, and a private patio or balcony. Select furnished homes are available. Step outside to enjoy the outdoor BBQ grilling area, pet stations, and smoke-free living, all overseen by on-site management and 24-hour emergency maintenance. Flexible leasing and ample on-site parking make settling in a breeze.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about our apartments or want to learn more about life at Confluence at Harvest Hills? Our knowledgeable leasing team is here to help you take the next step toward your new home in Williston, ND. Whether you contact us by phone, email, or contact form, we look forward to connecting with you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore thoughtfully designed layouts at Confluence at Harvest Hills. With options ranging from roomy one-bedroom to versatile two- and three-bedroom apartments, you'll have space for everything you love, from your home office to your favorite reading nook. Enjoy in-unit laundry, generous closets, and a private patio or balcony for quiet evenings or sunny mornings spent outside. Whether you're working from home or need extra storage, each floor plan balances space, light, and ease.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the space that fits your needs at Confluence at Harvest Hills in Williston, ND.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our photo gallery and imagine life at Confluence at Harvest Hills. See layouts with open living areas, bright kitchens with abundant storage, and your own balcony or patio for sunrise coffee. Discover cozy corners for both quiet nights in and lively gatherings with friends. Our images give you a real sense of space, style, and the welcoming atmosphere you'll enjoy every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Style and Everyday Ease at Confluence at Harvest Hills</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life in the Harvest Hills neighborhood at Confluence at Harvest Hills puts the best of Williston, ND within easy reach. Morning strolls are just steps away at Cote Park, while weekends bring you to Williston Municipal Golf Course for laid-back afternoons. Grab a coffee from Meg-A-Latte Coffee House or satisfy your sweet craving at Cold Stone Creamery, both within walking distance. Living here means you're close to Highway 2 for quick access to downtown Williston, Walmart for day-to-day needs, and Williston High School if you're commuting to school. Everything you need for work, play, and relaxation is at your doorstep.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in the Harvest Hills neighborhood, Confluence at Harvest Hills places you close to Williston High School, the Williston Municipal Golf Course, and handy shopping at Walmart. Wake up with a coffee from Meg-A-Latte Coffee House or treat yourself at Cold Stone Creamery, all within easy reach. Outdoor options like Cote Park invite you to stretch your legs, while downtown Williston is less than a ten-minute drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for apartments for rent in Williston, ND? At Confluence at Harvest Hills, your lifestyle comes first. Choose from spacious one-, two-, or three-bedroom apartments designed for comfort. Each home features in-unit laundry, a private patio or balcony, and roomy closets, making it easy to settle in and unwind. Enjoy the convenience of a pet-friendly community with options like oversized vehicle parking and flexible lease terms. Everyday routines are elevated, thanks to oversized closets, energy-efficient appliances, and a warm, inviting vibe throughout.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to find your next apartment in Williston, ND? Schedule a visit to Confluence at Harvest Hills and explore your options in person or online. Choose a private, guided walkthrough with a leasing professional or opt for a live virtual tour from home. Use our calendar to select the best date and time for you. Get a feel for the community's vibe, see your future kitchen, and picture yourself relaxing on the balcony. Restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Confluence at Harvest Hills from wherever you are with our immersive virtual tour. Walk through our open floor plans, picture yourself relaxing in bright living spaces, and get a feel for our community's friendly vibe, all before you visit in person. Whether browsing on your break or sharing with family, our online tour lets you view layouts and spaces that make everyday living comfortable.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-2521-7717-a76d-9b1f033d8d5c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living area with sofa, loveseat, coffee table, and a kitchen bar with three stools."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-3470-7229-b144-daefee3e9d00.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept kitchen with island counter, double sink, white appliances, and three bar stools."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-2edb-7318-abca-00598269259d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a bed, two nightstands, lamps, and a sliding glass door to a balcony."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-fc64-72f5-8bea-b8db66ec0bc7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a multifamily community building with brick accents, arched glass entrance, and green lawn."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-cb1c-740f-9875-f7e48b2b63c2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment kitchen with wooden cabinets, white appliances, and a bar-height counter with stools."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-43e5-72d5-8f4c-412dee52ba28.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Couple sits on a sofa with a small dog in a living room."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-c22d-70f2-81c8-12c6cc774cdd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor patio with people seated at tables along a colorful wall beside a building."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-cb1c-740f-9875-f7e48b2b63c2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment kitchen with wooden cabinets, white appliances, and a bar-height counter with stools."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-2edb-7318-abca-00598269259d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a bed, two nightstands, lamps, and a sliding glass door to a balcony."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-2f01-70bb-b486-91ccbc28e0cf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living area with sofa, loveseat, coffee table, and a kitchen with a breakfast bar and stools."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
